module.exports = __webpack_public_path__ + "static/media/Ex5-S2.9411fa6d.PNG";